import Vue from 'vue'
import Router from 'vue-router'
import Nprogress from 'nprogress'
import HorizontalLayout from 'Container/HorizontalLayout'
import HorizontalLayoutNoAuth from 'Container/HorizontalLayoutNoAuth'
import { store } from '@/store/store'

import rutasSession from '../modules/session/routes'
import rutasDashboard from '../modules/dashboard/routes'
import rutasAdministracion from '../modules/administracion/routes'
import rutasPacientes from '../modules/pacientes/routes'
import rutasTesoreria from '../modules/tesoreria/routes'
import rutasConsulta from '../modules/consulta/routes'
import rutasInbox from '../modules/inbox/routes'
import rutasReportes from '../modules/reportes/routes'

import storageUtil from '@/helpers/storage'
// const NotFoundView = () => import('Modules/session/views/SignUpOne')
// routes

Vue.use(Router)

const rutas = [].concat(rutasDashboard, rutasAdministracion, rutasPacientes, rutasTesoreria, rutasInbox, rutasReportes, [])
const rutasNoAuth = [].concat(rutasConsulta, [])

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: HorizontalLayout,
      redirect: '/dashboard',
      children: rutas
    }
  ].concat(rutasSession).concat([
    {
      path: '/',
      component: HorizontalLayoutNoAuth,
      redirect: '/',
      children: rutasNoAuth
    }
  ])
})

// navigation guards before each
router.beforeEach((to, from, next) => {
  store.commit('seleccionarMenu', { menu: null })
  if (typeof to.meta.menu !== 'undefined') {
    let menuPadre = store.getters.menus.filter(item => item.key && item.key === to.meta.menu)
    if (menuPadre.length > 0) {
      store.commit('seleccionarMenu', { menu: menuPadre[0] })
    }
  }

  Nprogress.start()
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth
  })) {
    if (storageUtil.getKey('user', true) === null) {
      next({
        name: 'login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

// navigation guard after each
router.afterEach((to, from) => {
  Nprogress.done()
  setTimeout(() => {
    const contentWrapper = document.querySelector('.v-content__wrap')
    if (contentWrapper !== null) {
      contentWrapper.scrollTop = 0
    }
  }, 200)
})

export default router
